




















































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import menuModule from '@/model/store/modules/menu-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import {GlobalAuthority, AuthorityNum} from '@/common/authority';
import {GCIMenuRes, GCIMenuInfoRes} from '@/model/dto/res/menu/get-menu-info-res';
import {PUMDataReq, PostUpsertMenuReq} from '@/model/dto/req/menu/post-upsert-menu-req';
import {CategoryInfoInterface} from '@/model/interfaces/category-interface';
import { VueEditor, Quill } from 'vue2-editor';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
import Compressor from 'compressorjs';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
    'vue-editor': VueEditor
  }
})
export default class MenuEdit extends Vue {
  /** Data **/
  private customToolbar: any = [
    ['bold', 'italic', 'underline', 'link'],
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['image', 'code-block']
  ];
  private rules: Array<(v: string) => boolean> = [(v: string) => v.length <= this.text.maxlength.value && v.length > 0];
  private contentId: string = '';
  private customModulesForEditor: any = [
    { alias: 'imageDrop', module: ImageDrop },
    { alias: 'imageResize', module: ImageResize }
  ];
  private editorSettings: any = {
    modules: {
      imageDrop: true,
      imageResize: {}
    }
  };
  private isDisable: boolean = true;
  private feedbackId: string | null = null;
  private isTitleInput: boolean = false;
  private isTextInput: boolean = false;
  private time: number = 1000;

  /** Computed **/
  get categoryInfo() {
    return appModule.categoryInfo;
  }

  get results() {
    return menuModule.menuInfo;
  }

  set title(val: string) {
    menuModule.pushMenuTitle(val);
  }

  get title() {
    return menuModule.menuInfo?.title ?? '';
  }

  set texts(val: string) {
    menuModule.pushMenuText(val);
  }

  get texts() {
    const text = menuModule.menuInfo?.text ?? '';
    return text;
  }

  get userType() {
    return userModule.type;
  }

  get isAuthorityNumber() {
    return userService.isAuthorityNumber(userModule.type);
  }

  get Learner() {
    return AuthorityNum.Learner;
  }

  get upsertStatus() {
    return contentsModule.upsertStatus;
  }

  get uploadImageInfo() {
    return contentsModule.uploadImageInfo;
  }

  get isSave() {
    this.checkSave();
    return this.isDisable;
  }

  get userId() {
    return userModule.userId;
  }

  get userName() {
    return userModule.userName;
  }

  get text() {
    return {
      save: GlobalConstants.TEXT.SAVE,
      preview: GlobalConstants.TEXT.PREVIEW,
      feedback: GlobalConstants.TEXT.FEEDBACK,
      allow: GlobalConstants.TEXT.ARROW,
      comment: GlobalConstants.TEXT.COMMENT,
      confirmation: GlobalConstants.TEXT.SAVECONFIRMATION,
      aconfirmation: GlobalConstants.TEXT.ALLOWCONFIRMATION,
      fconfirmation: GlobalConstants.TEXT.FEEDBACKCONFIRMATION,
      issave: GlobalConstants.TEXT.ISSAVE,
      showpreview: GlobalConstants.TEXT.SHOWPREVIEW,
      cautionfeedback: GlobalConstants.TEXT.CAUTIONFEEDBACK,
      maxlength: {
        value: GlobalConstants.TEXT.MAXLENGTH.VALUE,
        hint: GlobalConstants.TEXT.MAXLENGTH.HINT,
        label: GlobalConstants.TEXT.MAXLENGTH.LABEL
      }
    };
  }

  /** Methods **/
  private checkSave(): void {
    const title: string = this.title;
    const text: string =  this.texts;
    this.isDisable = title === '' && text === '' ||
                     title === '' && text !== '' ||
                     title !== '' && text === '';
  }

  private async onSave() {

    const params = this.getParam('SAVE');
    params.status = 2;

    await appModule.updateIsConfirmationDialog({
      type: 'menuSave',
      state: true,
      title: `${this.text.issave}`,
      message: `${this.text.confirmation}`,
      data: params
    });

  }

  // プレビュー表示
  private async onPreView() {
    this.isTitleInput = false;
    this.isTextInput = false;
    const params = this.getParam('PREVIEW');
    appModule.startLoading();
    const func = _.debounce(async () => {
      await detailModule.updateIsPreviewDialog({
        state: true,
        title: `${this.text.preview}`,
        message: `${this.text.showpreview}`,
        accountData: params
      });
      appModule.stopLoading();
    }, this.time);
    func();
  }

  private async imageAdded(file: File, Editor: any, cursorLocation: number, resetUploader: () => void): Promise<void> {
    const contentId =　1;
    const compressor = new Compressor(file, {
      convertSize: GlobalConstants.IMAGE.CONVERTSIZE,
      quality: GlobalConstants.IMAGE.QUALITY,
      async success(result: File) {
        const param = {
          file: result,
          contentId
        };
        /*await contentsModule.requestUploadImageContentsInfo(param);
        Editor.insertEmbed(cursorLocation, 'image', `${contentsModule.uploadImageInfo.path}`);
        resetUploader();*/
      },
      async error(err: Error) {
        console.log(err.message);
      },
    });
  }

  /*
   * getParam
   * api通信用のパラメータを設定
   * @type: SAVE, PREVIEW, ALLOW, FEEDBACK
   */
  private getParam(type: string): PUMDataReq {

    const id = 1;
    let status = menuModule.menuInfo.status;
    const title: string = menuModule.menuInfo.title;
    const text: string = menuModule.menuInfo.text;
    const deleted: boolean = menuModule.menuInfo.deleted;

    switch (type) {
      case 'SAVE':
        break;
      case 'PREVIEW':
        break;
      case 'ALLOW':
        status = 2;
        break;
      default: break;
    }

    const params: PUMDataReq = {
      id,
      title,
      text,
      status,
      deleted
    };
    return params;
  }

  /** Watch **/
  @Watch('upsertStatus')
  private doUpsertStatus() {}

  @Watch('uploadImageInfo')
  private doUploadImageInfo() {
    // 新規投稿時に画像をアップする際に生成されるディレクトリ名をcontentIDに設定する
    // this.contentId = contentsModule.uploadImageInfo.path !== '' ? contentsModule.uploadImageInfo.path.split('/').slice(-2)[0] : '';
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    appModule.startLoading();
    await menuModule.requestMenuInfo(1);
    this.checkSave();
    appModule.stopLoading();
  }

}
